/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../button/button.ngfactory';
import * as import2 from 'ionic-angular/components/button/button';
import * as import3 from 'ionic-angular/config/config';
import * as import4 from '@angular/common';
import * as import5 from 'ionic-angular/components/toast/toast-component';
import * as import6 from 'ionic-angular/navigation/view-controller';
import * as import7 from 'ionic-angular/navigation/nav-params';
const styles_ToastCmp:any[] = ([] as any[]);
export const RenderType_ToastCmp:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_ToastCmp,
  data: {}
}
);
function View_ToastCmp_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'toast-message'
      ]
      ],[[
        8,
        'id',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵinlineInterpolate(1,'',co.hdrId,'');
    ck(v,0,0,currVal_0);
    const currVal_1:any = co.d.message;
    ck(v,1,0,currVal_1);
  });
}
function View_ToastCmp_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'button',[
      [
        'class',
        'toast-button'
      ]
      ,
      [
        'clear',
        ''
      ]
      ,
      [
        'ion-button',
        ''
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.cbClick()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import1.View_Button_0,import1.RenderType_Button)),
    import0.ɵdid(1097728,(null as any),0,import2.Button,[
      [
        8,
        ''
      ]
      ,
      import3.Config,
      import0.ElementRef,
      import0.Renderer
    ]
      ,{clear: [
        0,
        'clear'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,[
      ' ',
      ' '
    ]
    ))
  ]
  ,(ck,v) => {
    const currVal_0:any = '';
    ck(v,1,0,currVal_0);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = (co.d.closeButtonText || 'Close');
    ck(v,2,0,currVal_1);
  });
}
export function View_ToastCmp_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'toast-wrapper'
      ]
    ],[
      [
        2,
        'toast-bottom',
        (null as any)
      ]
      ,
      [
        2,
        'toast-middle',
        (null as any)
      ]
      ,
      [
        2,
        'toast-top',
        (null as any)
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[' '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'toast-container'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[' '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ToastCmp_1)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),[' '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ToastCmp_2)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),[' '])),
    (l()(),import0.ɵted((null as any),[' ']))
  ]
  ,(ck,v) => {
    var co:import5.ToastCmp = v.component;
    const currVal_3:any = co.d.message;
    ck(v,5,0,currVal_3);
    const currVal_4:any = co.d.showCloseButton;
    ck(v,8,0,currVal_4);
  },(ck,v) => {
    var co:import5.ToastCmp = v.component;
    const currVal_0:any = (co.d.position === 'bottom');
    const currVal_1:any = (co.d.position === 'middle');
    const currVal_2:any = (co.d.position === 'top');
    ck(v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
function View_ToastCmp_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'ion-toast',[[
        'role',
        'dialog'
      ]
    ],[
      [
        1,
        'aria-labelledby',
        0
      ]
      ,
      [
        1,
        'aria-describedby',
        0
      ]

    ]
    ,(null as any),(null as any),View_ToastCmp_0,RenderType_ToastCmp)),
    import0.ɵdid(4243456,(null as any),0,import5.ToastCmp,[
      import6.ViewController,
      import3.Config,
      import0.ElementRef,
      import7.NavParams,
      import0.Renderer
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).hdrId;
    const currVal_1:any = import0.ɵnov(v,1).descId;
    ck(v,0,0,currVal_0,currVal_1);
  });
}
export const ToastCmpNgFactory:import0.ComponentFactory<import5.ToastCmp> = import0.ɵccf('ion-toast',import5.ToastCmp,View_ToastCmp_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./node_modules/ionic-angular/components/toast/toast-component.ngfactory.ts